import { Link } from "react-router-dom";
import type { ContentDiscussion, ContentTopic } from "@/types/content";
import TopicRankItem from "@/components/feature/TopicRankItem";
import DiscussionCard from "@/components/feature/DiscussionCard";

interface Props {
  topics: ContentTopic[];
  discussions: ContentDiscussion[];
}

export default function RankingAndDiscussion({ topics, discussions }: Props) {
  return (
    <section className="w-full bg-background-200/50 border-y border-background-200/70">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14">
          <div>
            <div className="flex flex-wrap items-end justify-between gap-3">
              <div>
                <span className="inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-primary-600 mb-3">
                  <span className="w-6 h-px bg-primary-400" />
                  Hot Ranking
                </span>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
                  瓜田话题榜 TOP 5
                </h2>
              </div>
              <Link
                to="/topics"
                className="inline-flex items-center gap-1.5 text-sm text-primary-700 hover:text-primary-800 transition-colors whitespace-nowrap"
              >
                完整榜单
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            <div className="mt-6 rounded-lg bg-background-50 border border-background-200/80 px-5 md:px-6">
              {topics.map((topic, index) => (
                <TopicRankItem key={topic.id} topic={topic} rank={index + 1} />
              ))}
            </div>
          </div>

          <div>
            <div className="flex flex-wrap items-end justify-between gap-3">
              <div>
                <span className="inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-accent-700 mb-3">
                  <span className="w-6 h-px bg-accent-400" />
                  Discussion
                </span>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
                  讨论区正在交锋
                </h2>
              </div>
              <Link
                to="/discussion"
                className="inline-flex items-center gap-1.5 text-sm text-accent-700 hover:text-accent-800 transition-colors whitespace-nowrap"
              >
                进入讨论区
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            <div className="mt-6 flex flex-col gap-4">
              {discussions.map((item) => (
                <DiscussionCard key={item.id} item={item} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}